import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'my-art',
  template: require('./art.component.html'),
  styles: [require('./art.component.scss')],
})
export class ArtComponent implements OnInit, OnDestroy {
  @ViewChild('content') content: ElementRef;
  projects = [
    {
      id: 'argus',
      name: 'Argus',
      year: 2019,
      images: {
        thumb: 'argus-1.jpg',
        thumb2x: 'argus-1@2x.jpg',
      },
      width: 200,
      height: 133
    },
    {
      id: 'pulse-of-san-francisco',
      name: 'Pulse of San Francisco',
      year: 2017,
      images: {
        thumb: 'pulse-of-san-francisco-1.jpg',
        thumb2x: 'pulse-of-san-francisco-1@2x.jpg',
      },
      width: 200,
      height: 133
    },
    {
      id: 'faces-of-resistance',
      name: 'Faces of Resistance',
      year: 2017,
      images: {
        thumb: 'faces-of-resistance-1.jpg',
        thumb2x: 'faces-of-resistance-1@2x.jpg',
      },
      width: 200,
      height: 112
    },
    {
      id: 'water-pixels',
      name: 'Water Pixels',
      year: 2017,
      images: {
        thumb: 'water-pixels-1.jpg',
        thumb2x: 'water-pixels-1@2x.jpg',
      },
      width: 200,
      height: 150
    },
    {
      id: 'untitled-201502',
      name: 'Untitled',
      year: 2015,
      images: {
        thumb: 'untitled-201502.jpg',
        thumb2x: 'untitled-201502@2x.jpg',
      },
      width: 150,
      height: 200
    },
    {
      id: 'untitled-201412',
      name: 'Untitled',
      year: 2014,
      images: {
        thumb: 'untitled-201412.jpg',
        thumb2x: 'untitled-201412@2x.jpg',
      },
      width: 150,
      height: 200
    },
    {
      id: 'untitled-201408',
      name: 'Untitled',
      year: 2014,
      images: {
        thumb: 'untitled-201408.jpg',
        thumb2x: 'untitled-201408@2x.jpg',
      },
      width: 150,
      height: 200
    },
    {
      id: 'untitled-201406',
      name: 'Untitled',
      year: 2014,
      images: {
        thumb: 'untitled-201406.jpg',
        thumb2x: 'untitled-201406@2x.jpg',
      },
      width: 200,
      height: 150
    },
    {
      id: 'untitled-201404',
      name: 'Untitled',
      year: 2014,
      images: {
        thumb: 'untitled-201404.jpg',
        thumb2x: 'untitled-201404@2x.jpg',
      },
      width: 150,
      height: 200
    },
    {
      id: 'untitled-201310',
      name: 'Untitled',
      year: 2013,
      images: {
        thumb: 'untitled-201310.jpg',
        thumb2x: 'untitled-201310@2x.jpg',
      },
      width: 200,
      height: 150
    },
  ];

  constructor() { }

  ngOnInit() {
    let document = this.content.nativeElement.ownerDocument;
    document.body.className = 'inverse';
  }

  ngOnDestroy() {
    let document = this.content.nativeElement.ownerDocument;
    document.body.className = '';
  }

  src(project, version): string {
    return `//assets.francisli.com/${project.id}/${project.images[version]}`;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/art/art.component.ts